import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthCardBanner } from '../../components/AuthCardBanner';
import { TextInput } from '../../components/Inputs';
import { GradientButton } from '../../components/Buttons';

function Login() {
  useEffect(() => {
    document.title = 'Login | PromptSlate';
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    setErrorMessage('');
    event.preventDefault(); // Prevent the page from reloading

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
        email,
        password,
      });

      // Store the token in localstorage
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('accountType', response.data.account_type);
      localStorage.setItem('email', response.data.email);
      localStorage.setItem('name', response.data.name);
      localStorage.setItem('companyId', response.data.company_id);
      navigate('/dashboard');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error response from the server
        setErrorMessage(error.response.data.message || 'Something went wrong!');
      } else {
        // Network or unknown error
        setErrorMessage('An unknown error occurred.');
      }
    }
  };

  return (
    <div className="flex flex-row items-center justify-center h-screen bg-[#f8f7f2]">
      <div className="flex flex-row items-stretch w-4/12 h-[500px] bg-[#fcfcf7] border rounded-xl p-6 shadow-sm">
        <AuthCardBanner />
        <div className="w-7/12 flex flex-col justify-center p-4 pl-12">
          <span className="font-playfair text-xl font-semibold">Sign in to your account</span>
          {errorMessage && <div className="text-red-600 text-sm mt-5">{errorMessage}</div>}
          <form onSubmit={handleLogin} className="flex flex-col">
            <TextInput
              type="email"
              placeholder="Email"
              className="mt-8"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <TextInput
              type="password"
              placeholder="Password"
              className="mt-5"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="text-sm mt-5 text-[#606060]">
              <NavLink to="/forgot-password">Forgot password?</NavLink>
            </span>
            <GradientButton type="submit" className="mt-5 w-full">
              Sign in
            </GradientButton>
          </form>
          <span className="text-sm mt-6 text-[#606060]">
            <NavLink to="/signup">or create an account</NavLink>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Login;
